import type { ApiLabouring } from "@src/api/dictionaries/labouring";
import { formatFullName } from "../../text-services/formatFullName";

/**
 * Функция форматирования ФИО работника
 * @param labouring - Работник из справочника Работники
 * @param format -  Формат, к которому необходимо привести ФИО работника, \
 * Аргументы: `S` - инициал фамилии(SurName), `N` - инициал имени(Name), `P` - инициал отчества(Patronymic) \
 * Приписка `f` в конце аргумента означает full, т.е. вывести не инициал, а полностью \
 * __По умолчанию: `Sf N. P.`__ \
 * Примеры {@linkcode format}:
 * - `S.N.P` - вернёт инициалы в заданном порядке с нужным разделителем С.Р.Г
 * - `Sf N P` - вернёт Соскин Р Г
 * - `Nf Pf = S` - вернёт Роман Геннадьевич = С
 * @returns ФИО работника в соответствии с переданным форматом
 */
export const formatFullNameLabouring = (labouring: ApiLabouring, format: string = "Sf N. P."): string => {
    const { SurName, Name, Patronymic } = labouring;

    return formatFullName(SurName, Name, Patronymic, format);
};
